import api from '@pray/shared/utils/api';

import type { SeedIdsResponse, SeedProvider, SeededFilter, SeedSourceValue } from './types';

const SEED_IDS_URL = '/web/studio/admin/seed-emails/seeds/ids';

export type GetSeedIdsParams = {
  q?: string;
  isp?: SeedProvider | '';
  source?: SeedSourceValue | '';
  groupId?: string;
  seeded?: SeededFilter | '';
};

/**
 * Every seed uuid the current filters match, for "Select all filtered".
 *
 * The list route caps a page at 100 rows, so building the same selection from it would cost one
 * request per page. This one answers uuids only and is not paged.
 */
export async function getSeedIds({ q, isp, source, groupId, seeded }: GetSeedIdsParams = {}) {
  const params: Record<string, string> = {};
  if (q) params.q = q;
  if (isp) params.isp = isp;
  if (source) params.source = source;
  if (groupId) params.group_id = groupId;
  if (seeded) params.seeded = seeded;

  const res = await api.executeGetRequest<{ data: SeedIdsResponse }>(SEED_IDS_URL, params);
  return res.data.data;
}
